import { usePageAction } from '@repo/hooks/usePageAction';

type Props = {
  actionSection: string;
  pageIdentifier: string;
  additionalAttributes?: Record<string, string>;
};

export const useFilterEvents = ({ actionSection, pageIdentifier, additionalAttributes }: Props) => {
  const clearAllFiltersEvent = usePageAction({
    actionName: `${pageIdentifier}_filters_refreshed`,
    actionSection: actionSection,
    actionType: 'select',
  });

  const removeFilterEvent = usePageAction({
    actionName: `${pageIdentifier}_filters_removed`,
    actionSection: actionSection,
    actionType: 'select',
    additionalAttributes,
  });

  const updateFiltersEvent = usePageAction({
    actionName: `${pageIdentifier}_filters_interacted`,
    actionSection: actionSection,
    actionType: 'select',
    additionalAttributes,
  });

  const sortBySelectEvent = usePageAction({
    actionName: `${pageIdentifier}_sort_by_interacted`,
    actionSection: actionSection,
    actionType: 'select',
  });

  const showMoreButtonClickEvent = usePageAction({
    actionName: 'see_more_interacted',
    actionSection: actionSection,
    actionType: 'select',
  });

  return {
    clearAllFiltersEvent,
    removeFilterEvent,
    showMoreButtonClickEvent,
    sortBySelectEvent,
    updateFiltersEvent,
  };
};
